module.exports = __webpack_public_path__ + "static/media/contact.3cc78760.jpg";